import React from "react";
import { Link } from "react-router-dom";
// import '../../onreview/SuccessfullOnreview/';

const SuccessfullReviewActivity = ({ path }) => {
    console.log(path)
  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
        <img className="activityLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" my-4 successfully_message">
          You have successfully reviewed student Activity.
        </span>
        <Link to={path}>
          <button className="successfull_okay_btn">Okay</button>
        </Link>
      </div>
    </div>
  );
};

export default SuccessfullReviewActivity;
